<template>
    <div>
        <div
            v-if="onlyStreaming"
            class="buyflow-panel px-4 mb-4 bg-gray-200 text-center border border-solid border-border
                  text-2lg tablet:text-3lg text-navy-dark font-bold"
        >
              TV service isn’t currently available in your area, but you can still add premium channels to stream on your devices.
        </div>

        <!--    Buyflow - TV - New TV Page    -->
        <div v-else class="buyflow-panel mb-6">
            <!--    Buyflow - TV - New Services Section    -->
            <p class="text-2xl text-center font-bold mb-4">
                <span v-if="getServiceType === 'iptvServices'">Stream TV</span><span v-else>Tivo</span>
                 - Watch on all of your devices
            </p>

            <div class="grid grid-cols-1 desktop:grid-cols-2 w-60 desktop:w-148 widescreen:w-full m-auto mb-4">
                <ul class="list-disc m-auto">
                    <li>Live TV</li>
                    <li>On-demand programming</li>
                    <li>Streaming services on a single unified interface </li>
                </ul>
                <ul class="list-disc m-auto">
                    <li>Watch from your TV, tablet, or phone</li>
                    <li>Access thousands of Android TV apps</li>
                    <li>Local broadcast channels are included</li>
                </ul>
            </div>

            <!--    Buyflow - TV - New Packages Section    -->
            <TVPackagesCards
                :locals-plus="localsPlus"
                :family-plus="familyPlus"
                :variety-plus="varietyPlus"
                :hbo-max="streamingServices.hboMax"
                :get-service-price="getServicePrice"
                :channel-counts="packageChannelCounts"
                :is-package-selected="isPackageSelected"
                :has-selected-a-service="hasSelectedAService"
                :is-wow-market="isWowMarket"
                :main-service="getServiceType === 'iptvServices' ? streamTV : tivo"
                @decline="declineService($event)"
                @select-package="selectChannels($event)"
                @select-service="selectTVOptions($event)"
                @show-channel-lineup="toggleChannelLineup(true)"
            />

            <!--    Buyflow - TV - New Channel Search Section    -->
            <TVChannelSearch
                :is-panel="false"
                :channel-data="data"
                :center-heading="true"
                :locals-plus="localsPlus"
                :filtered-channels="filteredChannels"
                :is-package-selected="isPackageSelected"
                @select-package="selectChannels($event)"
                @select-service="selectTVOptions($event)"
                :has-selected-a-service="hasSelectedAService"
                :main-service="getServiceType === 'iptvServices' ? streamTV : tivo"
            />

            <!--    Buyflow - TV - New Premium Channel Section    -->
            <TVAdditionalChannelsCards v-if="premiumChannels.length"
                title="Premium Channels"
                :channels="premiumChannels"
                :is-package-selected="isPackageSelected"
                :has-selected-a-service="hasSelectedAService"
                @select-package="selectChannels($event)"
            />

            <!--    Buyflow - TV - New International Channel Section    -->
            <TVAdditionalChannelsCards v-if="internationalChannels.length"
                title="International Channels"
                :channels="internationalChannels"
                :is-package-selected="isPackageSelected"
                :has-selected-a-service="hasSelectedAService"
                @select-package="selectChannels($event)"
            />

            <!--    Buyflow - TV - New Equipment Upgrade Section    -->
            <DVRCards
                :tv-data="data"
                :get-service-type="getServiceType"
                :is-service-selected="isServiceSelected"
                :has-selected-a-service="hasSelectedAService"
                :extra-equipments-count="extraEquipmentsCount"
                @select-service="selectTVOptions($event)"
            />

        </div>

        <!--    Buyflow - TV - New Decline Section    -->
        <TVDeclineService :has-declined="hasDeclined"
                          :only-streaming="onlyStreaming"
                          :streaming-services="streamingServices"
                          :is-package-selected="isPackageSelected"
                          @decline-service="declineService($event)"
                          @select-streaming-service="selectChannels($event)"
        />

        <!--    Buyflow - TV - New TV Channel Table Popup    -->
        <TVChannelLineup v-bind="channelLineup"
                         :meta="meta"
                         :filtered-channels="filteredChannels"
                         @hide-channel-lineup="toggleChannelLineup(false)"
        />
    </div>
</template>
<script>
    import DVRCards from '~/Buyflow/components/DVRCards'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import TVServices from '~/Buyflow/components/TVServices'
    import TVPackages from '~/Buyflow/components/TVPackages'
    import TVChannelSearch from "../components/TVChannelSearch"
    import TVChannelLineup from '~/Buyflow/components/TVChannelLineup'
    import TVPackagesCards from '~/Buyflow/components/TVPackagesCards'
    import TVDeclineService from '~/Buyflow/components/TVDeclineService'
    import TVAdditionalChannels from '~/Buyflow/components/TVAdditionalChannels'
    import TVAdditionalChannelsCards from '~/Buyflow/components/TVAdditionalChannelsCards'

    export default {
        name: 'TVPage',
        components: {
            DVRCards,
            TVServices,
            TVPackages,
            TVChannelLineup,
            TVChannelSearch,
            TVPackagesCards,
            TVDeclineService,
            TVAdditionalChannels,
            TVAdditionalChannelsCards,
        },
        computed: {
            ...mapState({
                meta: state => state.meta,
                data: state => state.Buyflow.tv.data,
                tvOptions: state => state.Buyflow.tv.tvOptions,
                packages: state => state.Buyflow.tv.data.packages,
                channelLineup: state => state.Buyflow.tv.channelLineup,
                tivo: state => state.Buyflow.tv.data.tivoServices.tivo,
                installData: state => state.Buyflow.finalize.installData,
                streamTV: state => state.Buyflow.tv.data.iptvServices.streamTV,
                localsPlus: state => state.Buyflow.tv.data.packages.localsPlus,
                familyPlus: state => state.Buyflow.tv.data.packages.familyPlus,
                premiumChannels: state => state.Buyflow.tv.data.premiumChannels,
                varietyPlus: state => state.Buyflow.tv.data.packages.varietyPlus,
                streamingServices: state => state.Buyflow.tv.data.streamingServices,
                internationalChannels: state => state.Buyflow.tv.data.internationalChannels,
            }),
            ...mapGetters({
                isHidden: 'Buyflow/tv/isHidden',
                isMinimal: 'Buyflow/tv/isMinimal',
                isWowMarket: 'Buyflow/isWowMarket',
                hasDeclined: 'Buyflow/tv/hasDeclined',
                onlyStreaming: 'Buyflow/tv/onlyStreaming',
                getServiceType: 'Buyflow/tv/getServiceType',
                getServicePrice: 'Buyflow/tv/getServicePrice',
                filteredChannels: 'Buyflow/tv/filteredChannels',
                isServiceSelected: 'Buyflow/tv/isServiceSelected',
                isPackageSelected: 'Buyflow/tv/isPackageSelected',
                hasSelectedAService: 'Buyflow/tv/hasSelectedAService',
                extraEquipmentsCount: 'Buyflow/tv/extraEquipmentsCount',
                hasSelectedProInstall: 'Buyflow/finalize/hasSelectedProInstall',
                hasSelectedSelfInstall: 'Buyflow/finalize/hasSelectedSelfInstall',
            }),
            packageChannelCounts() {
                return {
                    localsPlus: this.filteredChannels?.localsPlus?.length ?? 40,
                    varietyPlus: this.filteredChannels?.varietyPlus?.length ?? 20,
                    familyPlus: this.filteredChannels?.familyPlus?.length ?? 20,
                }
            },
        },
        mounted() {
            this.pushEvent('checkout_flow', {
                'flow_step_name': 'customize tv',
                'flow_step_number': '2'
            });
            this.setSessionStatus({ session_status: 2, })
            this.setCurrentStep([2,'tv page'])

            if (this.isHidden){
                this.$router.push({ name: 'buyflow-voice'})
            }
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'Buyflow/setCurrentStep',
                selectChannels: 'Buyflow/tv/selectChannels',
                declineService: 'Buyflow/tv/declineService',
                setSessionStatus: 'Buyflow/setSessionStatus',
                selectTVOptions: 'Buyflow/tv/selectTVOptions',
                toggleChannelLineup: 'Buyflow/tv/toggleChannelLineup',
                submitInstallationFulfillment: 'Buyflow/finalize/submitInstallationFulfillment',
            }),
        },
    }
</script>
